<template>
  <div>
    <div class="status-container">
      <div :class="{active: status >= 1}">
        <span>1</span>
        <span>Create Order</span>
      </div>
      <div :class="{active: status >= 2}"></div>
      <div :class="{active: status >= 2}">
        <span>2</span>
        <span>Payment Information</span>
      </div>
      <div :class="{active: status == 3}"></div>
      <div :class="{active: status == 3}">
        <span>3</span>
        <span>Order Tracking</span>
      </div>
    </div>

    
    <div v-if="status == 1" style="display: flex; justify-content: center;">
      <div class="card p-6" style="width: 50%;">
        <span class="subtitle">Create New Order</span>
  
        <div style="display: grid; margin-top: 3rem;">
          <span class="filter-item-title">Client Number <a id="info-clientNumber-link" href="#"><i class="fa-light fa-circle-question"></i></a></span>
          <div class="grid-3-1 gap-1rem">
            <input type="text" class="filter-item-content" placeholder="Leave empty to auto-generate" v-model="order.clientNumber" @input="event => order.clientNumber = sanitize(event.target.value)"/>
            <button  class="btn-outline btn-outline-light" @click="generateClientNumber()">Generate</button>
          </div>
          <small>If empty, will be auto-generated</small>
          <b-popover target="info-clientNumber-link" triggers="hover" placement="bottom" custom-class="popover-info">
            <div>Client Number (required)</div>
            <span>CRITICAL: Client numbers are REQUIRED for all customers. VIBANs are allocated ONLY to client numbers, never to order references. If empty, a client number is auto-generated.</span>
          </b-popover>
        </div>
  
        <div style="display: grid; margin-top: 1rem;">
          <span class="filter-item-title">Order Reference (optional) <a id="info-reference-link" href="#"><i class="fa-light fa-circle-question"></i></a></span>
          <div class="grid-3-1 gap-1rem">
            <input type="text" class="filter-item-content" placeholder="Leave empty to auto-generate" v-model="order.reference" @input="event => order.reference = sanitize(event.target.value)"/>
            <button  class="btn-outline btn-outline-light" @click="generateReference()">Generate</button>
          </div>
          <small>If empty, will be auto-generated</small>
          <small style="color: #e7000b;" v-if="orderReferenceError">{{ orderReferenceError }}</small>
          <b-popover target="info-reference-link" triggers="hover" placement="bottom" custom-class="popover-info">
            <div>Order Reference</div>
            <span>Optional identifier for this specific order. Used in payment remittance info to help disambiguate when multiple orders have the same amount and date. VIBANs are NOT allocated to order references.</span>
          </b-popover>
        </div>
  
        <div style="display: grid; margin-top: 1rem;">
          <span class="filter-item-title">Amount (EUR)*</span>
          <input type="number" class="filter-item-content" placeholder="0.00" @input="event => handleAmount(event.target.value) "/>
          <small style="color: #e7000b;" v-if="amountError">{{ amountError }}</small>
        </div>
  
        <div style="display: grid; margin-top: 1rem;">
          <span style="font-weight: bold;">Order Date</span>
          <div class="filter-item-content">{{ formatDate(new Date()) }}</div>
          <small>Automatically set to today</small>
        </div>
  
          <div style="display: grid; margin-top: 1rem;">
          <span class="filter-item-title">Expected Payment Term</span>
          <div class="filter-item">
            <a id="payment-term-picker-link" 
              class="filter-item-content d-flex justify-content-between py-2 px-3"
              href="#">
              <span class="fixed-span-size">
                {{ this.order.executionDate == 0 ? 'Instant' : this.order.executionDate  }}
              </span>
              <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
            </a>
            <b-popover target="payment-term-picker-link" triggers="focus" placement="bottom" custom-class="popover">
              <div>
                <span :class="['popover-option', {'popover-option-selected':  this.order.executionDate == 0}]" @click="order.executionDate = 0">Instant</span>
                <span :class="['popover-option', {'popover-option-selected':  this.order.executionDate == 15}]" @click="order.executionDate = 15">15 Days</span>
                <span :class="['popover-option', {'popover-option-selected':  this.order.executionDate == 30}]" @click="order.executionDate = 30">30 Days</span>
                <span :class="['popover-option', {'popover-option-selected':  this.order.executionDate == 45}]" @click="order.executionDate = 45">45 Days</span>
                <span :class="['popover-option', {'popover-option-selected':  this.order.executionDate == 60}]" @click="order.executionDate = 60">60 Days</span>
              </div>
            </b-popover>
          </div>
        </div>
  
        <div style="display: grid; margin-top: 1rem;">
          <span class="filter-item-title">Customer Email (optional)</span>
          <input type="text" class="filter-item-content" placeholder="customer@example.com" @input="event => order.customerEmail = sanitize(event.target.value)"/>
        </div>
  
        <div class="grid-2-1 gap-1rem mt-2rem">
          <button @click="createOrder()" class="btn-outline btn-dark">Create Order</button>
          <button @click="viewOrder()" class="btn-outline btn-outline-light">View All Orders</button>
        </div>
      </div>
    </div>

    <div v-else-if="status == 2">
      <alert-modal v-if="isAlertOpen">
        <span><i class="fa-solid fa-circle-check"></i>New invoice {{ this.invoice.InvoiceIdentifier }} has been successfully created for VIBAN {{ this.invoice.VIBAN }}</span>
      </alert-modal>
      <div class="grid-3-1 gap-0-2rem">
        <div>
          <div class="card p-6">
            <div style="display: flex; justify-content: space-between;">
              <span style="font-weight: bold;" class="subtitle">Select Payment Method</span>
              <span style="color: #008236; background-color: #dcfce7; border: none; font-size: 0.9rem;" v-if="isSelected" class="btn-empty">Selected</span>
            </div>
            <div class="grid-1-1-1 mt-2rem gap-1rem">
              <div style="display: flex; flex-direction: row; gap: 1rem;" @click="isSelected = true" :class="['card p-6', {active: isSelected}]">
                <i :style="{'background-color': isSelected ? '#155dfc':'#4a5565', 'border-radius': '0.625rem', padding: '1rem', width: '3rem', height: '3rem', color: 'white', display: 'flex', 'justify-content': 'center', 'align-items': 'center'}" class="fa-regular fa-building"></i>
                <div style="display: grid;">
                  <span style="font-weight: bold;">Digital Credit Transfer <i v-if="isSelected" style="color: #155dfc;" class="fa-regular fa-circle-check"></i></span>
                  <small>Secure bank transfer</small>
                  <div>
                    <span style="color: #008236; background-color: #dcfce7; border: none; font-size: 0.9rem;" class="btn-empty">Instant</span>
                    <span style="color: #1d4ed8; background-color: #dbeafe; border: none; font-size: 0.9rem;" class="btn-empty">Automated</span>
                  </div>
                </div>
              </div>
              <div style="display: flex; flex-direction: row; gap: 1rem;" class="card p-6 disabled">
                <i style="background-color: #4a5565; border-radius: 0.625rem; padding: 1rem; height: 3rem; color: white; display: flex; justify-content: center; align-items: center;" class="fa-regular fa-circle-check"></i>
                <div style="display: grid;">
                  <span style="font-weight: bold;">E-mandate</span>
                  <small>Automated direct debit</small>
                </div>
              </div>
              <div  style="display: flex; flex-direction: row; gap: 1rem;" class="card p-6 disabled">
                <i style="background-color: #4a5565; border-radius: 0.625rem; padding: 1rem; height: 3rem; color: white; display: flex; justify-content: center; align-items: center;" class="fa-regular fa-credit-card"></i>
                <div style="display: grid;">
                  <span style="font-weight: bold;">Credit Card</span>
                  <small>Visa, Mastercard, Amex</small>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isSelected" style="display: grid; gap: 1rem;" class="card p-6">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <span class="subtitle">Payment Instructions</span>
              <div style="display: flex; gap: 1rem;">
                <button class="btn-outline-light" @click="copyVIBAN()"><i class="fa-light fa-clone"></i>Copy IBAN</button>
                <button class="btn-outline-light" @click="download()"><i class="fa-light fa-arrow-down-to-bracket"></i>Download</button>
              </div>
            </div>
            <div>
              <small>IBAN</small>
              <div class="filter-item-content bordered">
                <span style="color: black;">{{ this.invoice.VIBAN.replace(/(.{4})(?!$)/g, '$1 ') }}</span>
              </div>
            </div>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
              <div>
                <small>Reference</small>
                <div class="filter-item-content bordered">
                  <span style="color: black; font-weight: bold;">{{ this.invoice.InvoiceIdentifier }}</span>
                </div>
              </div>
              <div>
                <small>Amount</small>
                <div class="filter-item-content bordered">
                  <span style="color: black; font-weight: bold;">€{{ this.invoice.Amount }}</span>
                </div>
              </div>
            </div>
            <div>
              <small>Expected Processing Time</small>
              <div class="filter-item-content bordered" style="display: flex; gap: 1rem;">
                  <span>Instant: ~1 minute</span>
                  <div style="border-left: 2px solid #0000001a;"> </div>
                  <span>Regular: 2-3 days</span>
              </div>
            </div>
            <div class="info-container">
              <i style="color: #155dfc;" class="fa-light fa-circle-exclamation"></i>
              <span><span style="color: #1c398e; font-weight: bold;">Important:</span> This IBAN is <span style="color: #155dfc; font-weight: bold;">unique to your account</span> and enables automatic payment reconciliation.</span>
            </div>
          </div>
        </div>
        <div style="height: fit-content;" class="card p-6">
          <span class="subtitle">Order Summary</span>
          <div class="mt-2rem" style="display: flex; justify-content: space-between; border-bottom: 1px solid #0000001a; padding: 0.5rem 0rem; margin-bottom: 0.5rem;">
            <span style="color: #4a5565;">Reference:</span>
            <span style="font-weight: bold;">{{ this.invoice.InvoiceIdentifier }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; border-bottom: 1px solid #0000001a; padding: 0.5rem 0rem; margin-bottom: 0.5rem;">
            <span style="color: #4a5565;">Type:</span>
            <span style="font-weight: bold;">One-time</span>
          </div>
          <div style="display: flex; justify-content: space-between; border-bottom: 1px solid #0000001a; padding: 0.5rem 0rem; margin-bottom: 0.5rem;">
            <span style="color: #4a5565;">Term:</span>
            <span style="font-weight: bold;">{{ this.order.executionDate == 0 ? 'Instant' : this.order.executionDate + ' days' }}</span>
          </div>
          <div style="display: flex; justify-content: space-between; border-bottom: 1px solid #0000001a; padding: 0.5rem 0rem; margin-bottom: 0.5rem;">
            <span style="color: #4a5565;">Date:</span>
            <span style="font-weight: bold;">{{ new Date(this.invoice.PaymentDate).toLocaleDateString() }}</span>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <span style="color: #4a5565;">Total:</span>
            <span style="font-weight: bold;">€{{ Number(this.invoice.Amount).toFixed(2) }}</span>
          </div>
        </div>
      </div>
      <div v-if="isSelected" class="grid-1-1 gap-2rem">
        <create-payment-modal :payment="{VIBAN: invoice.VIBAN, reference: invoice.Reference1, paymentDate: invoice.PaymentDate, amount: invoice.Amount}"></create-payment-modal>
        <button class="btn-outline btn-dark" @click="status = 3">I have made the transfer → Track Status</button>
      </div>
    </div>

    <div v-else class="card p-6">
      <div class="grid-1-1-1">
        <div style="display: grid;">
          <small>Order Reference</small>
          <span>{{ this.invoice.InvoiceIdentifier }}</span>
        </div>
        <div style="display: grid;">
          <small>Order Amount</small>
          <span>€{{ Number(this.invoice.Amount).toFixed(2) }}</span>
        </div>
        <div style="display: grid;">
          <small>Current Status</small>
          <span style="color: #334155; background-color: #f8fafc; border-color: #e2e8f0;" class="btn-selection" v-if="this.invoice.Status == 0">Created</span>
          <span style="border-color: #ffc9c9; background-color: #ffe2e2; color: #9f0712;" class="btn-selection" v-else-if="this.invoice.Status == 1">Not Reconciled</span>
          <span style="color: rgb(161, 98, 7); background-color: rgb(254, 252, 232); border-color: rgb(254, 240, 138);" class="btn-selection" v-else-if="this.invoice.Status == 2">Partially Paid</span>
          <span style="border-color: rgb(185, 248, 207); background-color: rgb(240, 253, 244); color: rgb(0, 130, 54);" class="btn-selection" v-else-if="this.invoice.Status == 3">Reconciled</span>
          <span v-else>—</span>
        </div>
      </div>
      <hr class=" mt-2rem">
      <div class="grid-2-1 gap-2rem mt-2rem">
        <div style="display: grid; gap: 1rem;">
          <span class="subtitle">Payment Information</span>
          <div>
            <small>IBAN</small>
            <div style="border-color: #ebe6e7;" class="filter-item-content">
              <span style="color: #000;">{{ this.invoice.VIBAN.replace(/(.{4})(?!$)/g, '$1 ') }}</span>
            </div>
          </div>
          <div>
            <small>Required Reference</small>
            <div style="border-color: #fef08a; background-color: #fefce8 !important; color: #000;" class="filter-item-content">
              <span>{{ this.invoice.InvoiceIdentifier}}</span>
            </div>
          </div>
        </div>
        <div style="display: grid; gap: 0.5rem;">
          <div style="display: flex; justify-content: space-between; align-items: baseline;">
            <span class="subtitle">Order Details</span>
            <button style="background-color: #2b7fff; border-color: #2b7fff; height: 3rem;" class="btn-outline btn-dark" @click="checkPaymentStatus()"> <i class="fa-regular fa-refresh"></i> Check Payment Status</button>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <small>Customer Type:</small>
            <span>One-time</span>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <small>Created:</small>
            <span>{{ new Date(this.invoice.PaymentDate).toLocaleDateString() }}</span>
          </div>
        </div>
      </div>
      <div class=" mt-2rem">
        <span class="subtitle">Order Timeline</span>
        <div class="grid-1-1-1 mt-2rem">
          <div>
            <div style="display: flex; align-items: center; gap: 0.25rem;">
              <div style="border-bottom: 2px solid #0000001a;width: 50%;"></div>
              <div style="border-radius: 50%; background-color: #00c951; padding: 0.75rem; display: flex; justify-content: center; align-items: center;">
                <i style="font-weight: bold; color: white; font-size: 1.5rem;" class="fa-regular fa-check"></i>
              </div>
              <div style="border-bottom: 2px solid #0000001a;width: 50%"></div>
            </div>
            <div style="display: grid; justify-items: center; margin-top: 1rem;">
              <span style="color: #00a63e;">Order Created</span>
              <span style="color: #99a1af;">{{ new Date(this.invoice.PaymentDate).toLocaleDateString() + ', ' + new Date(this.invoice.PaymentDate).toLocaleTimeString() }}</span>
            </div>
          </div>
          <div>
            <div style="display: flex; align-items: center; gap: 0.25rem;">
              <div style="border-bottom: 2px solid #0000001a;width: 100%"></div>
              <div :style="{'border-radius': '50%', 'background-color': this.invoice.Status == 2 ? 'rgb(161, 98, 7)' : this.invoice.Status == 3 ? '00c951' : '#2b7fff', 'padding': '0.75rem', display: 'flex', 'justify-content': 'center', 'align-items': 'center'}">
                <i style="color: white; font-size: 1.5rem;" class="fa-regular fa-clock"></i>
              </div>
              <div style="border-bottom: 2px solid #0000001a;width: 100%"></div>
            </div>
            <div style="display: grid; justify-content: center; margin-top: 1rem;">
              <span style="color: #155dfc;">{{ this.invoice.Status == 2 ? 'Partially paid': this.invoice.Status == 3 ? 'Payment received' : 'Waiting for Payment' }}</span>
            </div>
          </div>
          <div>
            <div style="display: flex; align-items: center; gap: 0.25rem;">
              <div style="border-bottom: 2px solid #0000001a;width: 100%"></div>
              <div :style="{'border-radius': '50%', 'background-color': this.invoice.Status == 2 ? 'rgb(161, 98, 7)' : this.invoice.Status == 3 ? '00c951' : '#0000001a', 'padding': '0.75rem', display: 'flex', 'justify-content': 'center', 'align-items': 'center'}">
                <i style="font-weight: bold; color: #99a1af; font-size: 1.5rem;" class="fa-regular fa-check"></i>
              </div>
              <div style="border-bottom: 2px solid #0000001a;width: 100%;"></div>
            </div>
            <div style="display: grid; justify-items: center; margin-top: 1rem;">
              <span style="color: #99a1af;">Payment Confirmation</span>
            </div>
          </div>
        </div>
        <div class="grid-1-1 gap-1rem mt-2rem">
          <button class="btn-outline-light btn" @click="viewOrder()">View All Orders</button>
          <button style="background-color: #2b7fff; border-color: #2b7fff;" class="btn-outline btn-dark" @click="createNewOrder()">Create New Order</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertModal from './alertModal.vue';
import DateTimePicker from './dateTimePicker.vue';
import MakePaymentModal from './makePaymentModal.vue';

export default {
  components: { 
    AlertModal,
    'datetime-picker': DateTimePicker,
    'create-payment-modal' : MakePaymentModal
  },
  name: 'createOrderModal',
  emits: ['update:status'],
  data(){
    return {
      status: 1,
      order: {
        date: null,
        dueDate: null,
        executionDate: 0,
        amount: null,
        reference: null,
        customerEmail: null,
        VIBAN: null,
        clientNumber: null
      },
      invoice: {},
      isAlertOpen: false,
      isSelected: false,
      amountError: null,
      orderReferenceError: null
    }
  },
  methods: {
    async createOrder (){
      const isAvailable = await this.checkAllocation(this.order.reference)

      if(!isAvailable){
        this.orderReferenceError = "This reference already exists, enter a unique order reference"
        return
      }

      if(Number(this.order.amount) == null || Number(this.order.amount) <= 0) {
        this.amountError = "This field can't be empty or equal to 0, please enter a valid amount"  
        return
      }

      if(this.amountError != null) {
        return
      }
      
      this.order.date = new Date()

      const dueDate = new Date(this.order.date)
      dueDate.setDate(dueDate.getDate() + this.order.executionDate)

      this.order.dueDate = dueDate

      this.order.reference ?? this.generateReference()

      let invoice = {
        "InvoiceIdentifier": this.order.reference,
        "PaymentDate": this.order.date,
        "ExecutionDate": this.order.dueDate,
        "Amount": this.order.amount,
        'CustomerEmail': this.order.customerEmail,
        "Type": 'Standard',
        "Description": null,
        "Reference1": this.order.clientNumber,
        "VIBAN": null
      }

      this.$engine.services.payments.getGroups({search: this.order.clientNumber})
      .then(resp => {
        const data = resp.data
        if(data.references[0]){
          invoice.VIBAN = data.references[0].VIBAN

          this.$engine.services.payments.createInvoice(invoice)
          .then(resp=>{
            if(resp.status == 201) {
              this.invoice = invoice
              this.status = 2
              this.isAlertOpen = true;
              setTimeout(()=>{
                this.isAlertOpen = false;
              }, 3000)
            }
          })
        }else {
          this.generateClientNumber()
          
          this.$engine.services.payments.createGroup(this.order.clientNumber)
          .then(res => {
            if(res.status != 200) return

            invoice.VIBAN = res.data.VIBAN

            this.$engine.services.payments.createInvoice(invoice)
            .then(resp=>{
              if(resp.status == 201) {
                this.invoice = invoice
                this.status = 2
                this.isAlertOpen = true;
                setTimeout(()=>{
                  this.isAlertOpen = false;
                }, 3000)
              }
            })
          })
        }
      })
    },
    sanitize (value) {
      if (typeof value !== 'string') return ''

      return value
        .trim()
        .replace(/[^a-zA-Z0-9-_.]/g, '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/\r?\n|\r/g, '')
    },
    async generateClientNumber (){
      let clientNumber = 'CLI-' + Math.random().toString(20).substr(2, 8).toUpperCase()

      const isAvailable = await this.checkAllocationClient(clientNumber)
      
      if (!isAvailable) return this.generateClientNumber()

      this.order.clientNumber = clientNumber
    },
    async generateReference (){
      let reference = 'ORD-' + (Math.random().toString(20).substr(2, 6) + '-' + Math.random().toString(20).substr(2, 3)).toUpperCase()
      
      const isAvailable = await this.checkAllocation(reference)
      
      if (!isAvailable) return this.generateReference()

      this.order.reference = reference
    },
    async checkAllocation (data) {
      const resp = await this.$engine.services.payments.getInvoices({ Search: data })
      return (
        resp.data.Invoices.length === 0
      )
    },
    async checkAllocationClient (data) {
      const resp = await this.$engine.services.payments.getGroups({ Reference1: data })

      return (
        resp.data.references.length === 0
      )
    },
    isoToDDMMYYYY (isoDate) {
      const [year, month, day] = isoDate.split("T")[0].split("-");
      return `${year}-${month}-${day}`;
    },
    formatDate (date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    download () {
      const content = `PAYMENT INSTRUCTIONS\r\n=====================\r\n\r\nIBAN\r\n${this.invoice.IBAN}\r\n\r\nPAYMENT DETAILS\r\nReference: ${this.invoice.InvoiceIdentifier}\r\nAmount: €${this.invoice.Amount}\r\n\r\nEXPECTED PROCESSING TIME\r\n• Instant: ~1 minute\r\n• Regular: 2-3 days\r\n\r\nIMPORTANT\r\nThis IBAN is unique to your account and enables\r\nautomatic payment reconciliation.\r\n\r\nPlease use the exact IBAN and reference when making your payment.`.trim();

      const blob = new Blob([content], { type: 'text/plain;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'payment-instructions.txt';
      link.click();

      URL.revokeObjectURL(url);
    },
    async copyVIBAN (){
      try {
        await navigator.clipboard.writeText(this.invoice.VIBAN);
        this.copied = true;

        setTimeout(() => {
          this.copied = false;
        }, 2000);
      } catch (err) {
        console.amountError('Failed to copy IBAN', err);
      }
    },
    viewOrder (){
      this.order= {
        date: null,
        dueDate: null,
        executionDate: 0,
        amount: null,
        reference: null,
        customerEmail: null,
        VIBAN: null,
        clientNumber: null
      }

      this.invoice = null

      this.$emit('update:status', 'orderstatus')
    },
    createNewOrder (){
      this.order= {
        date: null,
        dueDate: null,
        executionDate: 0,
        amount: null,
        reference: null,
        customerEmail: null,
        VIBAN: null,
        clientNumber: null
      }

      this.invoice = null
      this.status = 1
    },
    checkPaymentStatus (){
      let filter = {
        Search: this.order.reference
      }
      this.$engine.services.payments.getInvoices(filter)
      .then(resp=> {
        if(resp.data.Invoices[0]){
          this.invoice = { VIBAN: this.invoice.VIBAN, ...resp.data.Invoices[0]}
        }
      })
    },
    handleAmount(amount){
      const numericAmount = Number(amount)

      this.order.amount = amount.length > 0 ? this.sanitize(amount) : null

      this.amountError = amount.length > 0 ? (isNaN(numericAmount) || numericAmount <= 0 ? "Amount must be greater than zero, please enter a valid amount" : null) : "This field can't be empty, please enter a valid amount"
    }
  }
}
</script>

<style scoped>

.btn-selection{
  font-weight: bold !important;
  display: flex;
  min-height: 0.5rem !important;
  width: fit-content;
  gap: 1rem;
  padding: 0.25rem 0.5rem !important;
  align-items: center;
  border: 1px solid;
  border-radius: calc(0.75rem - 2px);
  font-size: 0.85rem;
  cursor: default !important;
}

.filter-item-content{
  height: 3rem;
}

.filter-item-content.bordered{
  border-color: #d5d5d5;
  height: 3.5rem;
}

.info-container{
  display: flex;
  align-items: center;
  gap: 0rem 1rem;
  padding: calc(.25rem * 4);
  background-color: #eff6ff;
  border-left: 4px solid #51a2ff;
  color: #1c398e;
  margin: 1rem 0rem;
}

.disabled{
  opacity: .5;
  pointer-events: none;
  cursor: not-allowed;
  background-color: #fbf9fa;
  border: 2px solid #ebe6e7;
}

.card.active{
  border: 2px solid #2b7fff;
  background-color: #eff6ff;
}

small{
  color: #6a7282;
  font-size: 0.85rem;
  margin: 0.25rem 0rem;
}

.grid-2-1 {
  display: grid;
  grid-template-columns: 2fr 1fr;
}
.grid-3-1 {
  display: grid;
  grid-template-columns: 3fr 1fr;
}
.grid-1-1-1 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.grid-1-1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.gap-1rem {
  gap: 1rem;
}
.gap-2rem {
  gap: 2rem;
}
.gap-0-2rem {
  gap: 0rem 2rem;
}
.mt-2rem {
  margin-top: 2rem;
}
.mb-0 {
  margin-bottom: 0;
}

.subtitle{
  font-size: 1.25rem;
}

.status-container{
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 1rem;
  margin: 2rem 0rem;
}

.status-container>div:nth-child(even){
  border: 2px solid #e7e9ee;
  height: 1px;
  width: 10rem;
}

.status-container>div:nth-child(odd){
  display: grid;
  justify-items: center;
}

.status-container>div:nth-child(odd)>span:first-child{
  padding: 1rem;
  height: 3rem;
  width: 3rem;
  background-color: #e7e9ee;
  color: #6a7282;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
}

.status-container>div:nth-child(odd).active>span:first-child{
  color: white;
  background-color: #155dfc;
}

.status-container>div:nth-child(odd).active>span:last-child{
  color: #155dfc;
}

.status-container>div:nth-child(even).active{
  border: 2px solid #155dfc;
}

.status-container>div:nth-child(odd)>span:last-child{
  color: #6a7282;
  margin: 1rem 0rem;
}

</style>